import React from 'react';
import { classes, style } from 'typestyle';
import { Badge } from '../../../badge';
import { Button } from '../../atoms/button/Button';
import { ButtonSize, ButtonProminence } from '../../atoms/button/buttonStyles';
import { TrashIcon } from '../../atoms/icons/TrashIcon';
import { spacing } from '../../../../theme/spacing';
import { rebrand } from '../../../../theme/color';
import { important, px } from 'csx';
import { centerCenter, flexRoot } from 'csstips';

const styles = {
  clearWrapper: style({
    position: 'relative',
  }),
  clearBtn: style(flexRoot, centerCenter, {
    gap: spacing.XXSMALL,
    fontWeight: 'normal',
  }),
  filterBadge: style({
    position: 'absolute',
    color: rebrand.contrast[90].toString(),
    backgroundColor: rebrand.primary[50].toString(),
    height: important('24px'),
    width: important('24px'),
    fontSize: important('12px'),
    fontWeight: 700,
    top: px(-16),
    left: px(4),
  }),
};

interface ClearFiltersButtonProps {
  resetFilter: () => void;
  filterCount: number;
  className?: string;
}

export const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({ resetFilter, filterCount, className }) => {
  if (filterCount === 0) return null;

  return (
    <div className={classes(styles.clearWrapper, className)}>
      <Button
        className={styles.clearBtn}
        size={ButtonSize.MEDIUM}
        onClick={resetFilter}
        prominence={ButtonProminence.SECONDARY}
        data-test-clear-filter
      >
        <span> Clear filters </span>
        <TrashIcon />
      </Button>
      <Badge className={styles.filterBadge} searchBadge={true}>
        <span data-test-filter-count> {filterCount}</span>
      </Badge>
    </div>
  );
};
